import { systemAuditTheme } from './constants'

export const getStatusCodeColor = (statusCode: number): string => {
    if (statusCode >= 100 && statusCode <= 199) {
        return systemAuditTheme.statusColors.informational
    }
    if (statusCode >= 200 && statusCode <= 299) {
        return systemAuditTheme.statusColors.successful
    }
    if (statusCode >= 300 && statusCode <= 399) {
        return systemAuditTheme.statusColors.redirection
    }
    if (statusCode >= 400 && statusCode <= 499) {
        return systemAuditTheme.statusColors.error
    }
    if (statusCode >= 500 && statusCode <= 599) {
        return systemAuditTheme.statusColors.error
    }

    return systemAuditTheme.statusColors.error
}
